import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import { Button, makeStyles } from '@material-ui/core';
import { openAlertDialog } from '../../../redux/actions/dialogActions';
import { AlertDialogProps } from '../../../Utils/DialogUtils';
import { useDispatch } from 'react-redux';
const useStyles = makeStyles((theme) => ({
	buildError: {
		color: 'red',
		whiteSpace: 'nowrap',
	},
}));
// Artifact build error dialog component.
function ArtifactBuildError({ error }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const handleClick = () => {
		dispatch(openAlertDialog(new AlertDialogProps(error, 'Build Error')));
	};
	if (error) {
		return (
			<Button startIcon={<WarningIcon />} size="small" className={classes.buildError} onClick={handleClick}>
				Show Build Error
			</Button>
		);
	}
	return null;
}

export default ArtifactBuildError;
